module.exports = __webpack_public_path__ + "img/teddy-zoomed.7f8e7dce.jpg";